import { __decorate } from "tslib";
import videoPlayer from '@blade/common/components/task-management/player/task-player.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    viewDialogVisible;
    rtsp;
    title;
    handleClose() {
        this.$emit('update:viewDialogVisible', false);
    }
};
__decorate([
    Prop()
], default_1.prototype, "viewDialogVisible", void 0);
__decorate([
    Prop()
], default_1.prototype, "rtsp", void 0);
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
default_1 = __decorate([
    Component({
        name: 'viewModel',
        components: {
            videoPlayer
        },
        i18n: {
            messages: {
                en: {
                    cancel: 'cancel',
                    confirm: 'confirm',
                    RTSP: 'Direct camera /RTSP',
                    ONVIF: 'Direct camera /ONVIF',
                    deviceName: 'Device name',
                    groupName: 'Group name',
                    type: 'Type',
                    url: 'URL',
                    addDevice: 'Add Device'
                },
                zh: {
                    cancel: '取消',
                    confirm: '确定',
                    RTSP: 'Direct camera /RTSP',
                    ONVIF: 'Direct camera /ONVIF',
                    deviceName: '设备名称',
                    groupName: '组织名称',
                    type: '类型',
                    url: '网址',
                    addDevice: '添加设备',
                }
            }
        }
    })
], default_1);
export default default_1;
